import { AbstractGameController } from "@lib/titan2/dist/game/controller/AbstractGameController";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { gsap } from "gsap";
import { FeatureGreenFishEvents } from "../view/abstract/display/features/greenfish/FeatureGreenFish";
import { FeatureTransitionEvents } from "./FeatureTransitionController";
import { GameBigWinEvents } from "../view/abstract/display/GameBigWin";
import { GreenFishPrizeType } from "../model/data/ChanceGamesData";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { GameEvent } from "./event/GameEvent";
import { SeededRandom } from "../utils/SeededRandom";
import { MainTransitionEvents } from "../view/abstract/display/GameMainTransition";
export class FeatureGreenFishController extends AbstractGameController {
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(FeatureGreenFishControllerEvents.BEGIN_FEATURE, this.handleBeginFeature);
    }
    async handleBeginFeature() {
        const availableCupIndexes = Array.from({ length: 9 }, (x, i) => i);
        const seededRandomUserChoice = new SeededRandom(this.model.getGameInstanceId());
        const data = this.model.getGreenFishChanceGameData();
        const didCollect = data.getPickedPrize().type === GreenFishPrizeType.AWARD_ALL;
        this.dispatchGame(FeatureGreenFishEvents.FEATURE_START);
        await this.blockUntil(FeatureGreenFishEvents.PICKS_READY);
        let index;
        if (Service.isReplay()) {
            await this.delayFor(1);
            index = this.model.consumeNextUserChoice();
            if (index === null) {
                index = seededRandomUserChoice.pickFromArray(availableCupIndexes);
            }
        }
        else {
            index = (await this.blockUntil(FeatureGreenFishEvents.PICK_SELECTED)).getPayload()["index"];
            this.dispatchGame(GameEvent.createUserchoiceMadeEvent({ choice: index }));
        }
        if (!didCollect) {
            this.dispatchGame(new EventObject(FeatureGreenFishEvents.REVEAL_STANDARD_PRIZE.getType(), {
                index,
                prize: data.getPickedPrize(),
                missedPrizes: data.getMissedPrizes()
            }));
        }
        else {
            this.dispatchGame(new EventObject(FeatureGreenFishEvents.REVEAL_COLLECT_ALL_PRIZE.getType(), {
                index,
                prize: data.getPickedPrize(),
                missedPrizes: data.getMissedPrizes()
            }));
        }
        await this.blockUntil(FeatureGreenFishEvents.REVEAL_PRIZE_COMPLETE);
        this.dispatchGame(FeatureTransitionEvents.TRANSITION_WIN_PARTICLE);
        this.dispatchGame(GameBigWinEvents.PLAY);
        await this.blockUntil(GameBigWinEvents.COMPLETE);
        this.dispatchGame(FeatureTransitionEvents.TRANSITION_BACK_TO_BASE_GAME);
        await this.blockUntil(MainTransitionEvents.BLACKOUT_MID_POINT);
        this.dispatchGame(FeatureGreenFishEvents.CLEAR);
    }
    createModel() {
        super.createModel();
        this.model = this.baseModel;
    }
    async blockUntil(event) {
        return new Promise(resolve => {
            this.registerGame(event, (recievedEvent) => {
                this.unregisterGame(event);
                resolve(recievedEvent);
            });
        });
    }
    async delayFor(timeInSeconds) {
        return new Promise(resolve => {
            gsap.delayedCall(timeInSeconds, resolve);
        });
    }
}
export class FeatureGreenFishControllerEvents {
}
FeatureGreenFishControllerEvents.BEGIN_FEATURE = new EventObject("FeatureGreenFishEvents.BEGIN_FEATURE");
//# sourceMappingURL=FeatureGreenFishController.js.map